import DisplayDeliveryDetails from './DisplayDeliveryDetails';

export default DisplayDeliveryDetails;
